import React from "react";
import styles from "./index.module.scss";
import Button from "../../UI/Button";

export default function ContributeBanner() {
  return (
    <div className={styles.container}>
      <div className={styles.flex1}>
        <label>Want to contribute?</label>
        <p>
          If you would like to share your expertise on a mobile marketing or
          subscription app development topic, please get in touch with us. We'd
          love to hear from you!
        </p>
      </div>
      <Button
        onClick={() => (window.location = "mailto:support@apphud.com")}
        title={"Contact us"}
        className={styles.button}
      />
    </div>
  );
}
